import React from "react";

// reactstrap components
import { Button, Container, Row, Col} from "reactstrap";

// core components

function Contacts() {
  return (
    <>
      <div
        className="section section-download"
        data-background-color="black"
        id="download-section"
      >
        <Container>
          <div className="title">
            <h2>Contacts :</h2>
          </div>
          <Row className="text-center mt-5">
            <Col className="ml-auto mr-auto" md="8">
              <h5 className="description">
                <h3>Adresse postale :</h3>
Association Nuit INSA, INSA Hauts-de-France Mont Houy 59313 Valenciennes
                <br></br>
                <br></br>
                <h3>Président :</h3>
                Lucas Julhe
                <br></br>
                <br></br>
                <h3>Courriel :</h3>
<a href="mailto:nuitinsa@gmail.com">nuitinsa@gmail.com</a>
              </h5>
            </Col>
          </Row>
          <Row className="justify-content-md-center text-center">
            <Col className="text-center" lg="8" md="12">
              <h3>Nous sommes aussi présents sur Facebook, Instagram et LinkedIn !</h3>
            </Col>
            <Col className="text-center" lg="8" md="12">
              <Button
                className="btn-neutral btn-icon btn-round"
                color="facebook"
                href="https://www.facebook.com/galainsahdf"
                id="tooltip735272548"
                size="lg"
                target="_blank"
              >
                <i className="fab fa-facebook-square"></i>
              </Button>
              <Button
                className="btn-neutral btn-icon btn-round"
                color="linkedin"
                href="https://www.linkedin.com/company/nuit-insa/mycompany/"
                id="tooltip647117716"
                size="lg"
                target="_blank"
              >
                <i className="fab fa-linkedin"></i>
              </Button>
              <Button
                className="btn-neutral btn-icon btn-round"
                color="instagram"
                href="https://www.instagram.com/nuit_insa"
                id="tooltip331904895"
                size="lg"
                target="_blank"
              >
                <i className="fab fa-instagram"></i>
              </Button>
{/*               <UncontrolledTooltip delay={0} target="tooltip331904895">
                Star on Github
              </UncontrolledTooltip> */}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Contacts;
